import { createSlice } from '@reduxjs/toolkit';

// Counter (not a bool) so overlapping saves (e.g. a debounced auto-save firing
// again before the previous request resolves) don't let one's completion hide the other's.
const savingIndicatorSlice = createSlice({
  name: 'savingIndicator',
  initialState: { count: 0 },
  reducers: {
    savingStarted: (state) => {
      state.count += 1;
    },
    savingFinished: (state) => {
      state.count = Math.max(0, state.count - 1);
    },
  },
});

export const { savingStarted, savingFinished } = savingIndicatorSlice.actions;
export default savingIndicatorSlice.reducer;
